class SentryHelpers {

  getSentryDetails = (userProfile) => {
    const sentryUserDetail = {
      id: userProfile?.user?.org_id,
      email: userProfile?.user?.email,
      username: userProfile?.user?.first_name.trim(),
      organisation_name: userProfile?.user?.tenant_info?.organisation_name,
      tenant_id: userProfile?.user?.tenant_info?.tenant_id,
      tenant_name: userProfile?.user?.tenant_info?.legal_name,
    }

    return sentryUserDetail
  }

  getSentryTags = (userProfile) =>{
    const sentryTags = {
      org_id: userProfile?.user?.org_id,
      organisation_name: userProfile?.user?.tenant_info?.organisation_name,
      tenant_id: userProfile?.user?.tenant_info?.tenant_id,
      tenant_name: userProfile?.user?.tenant_info?.legal_name,
      user_id: userProfile?.user?.email,
      username: userProfile?.user?.first_name.trim(),
      email: userProfile?.user?.email,
    }

    return sentryTags
  }

}
export default new SentryHelpers();
